export default "__VITE_ASSET__DLnU6ZVz__"